import { ARBITRARY_ID_IS_ONLINE, DOMAIN_TYPE_ARBITRARY } from '../../../consts';
export var getIsOnlineStatus = function (state) {
    var isOnlineStateSlice = getIsOnlineArbitraryState(state) || {};
    // if undefined, the online/offline event never happened, assume is online
    if (typeof isOnlineStateSlice.status === 'undefined') {
        return true;
    }
    return isOnlineStateSlice.status;
};
export var getIsOnlineArbitraryState = function (state) {
    return (state.domain[DOMAIN_TYPE_ARBITRARY] || {})[ARBITRARY_ID_IS_ONLINE];
};
